module.exports = __webpack_public_path__ + "img/activities.4ae7e9a3.svg";